(function () {
  var instances = {};

  function initSlider(container) {
    if (!container || typeof Swiper === 'undefined') {
      return;
    }

    var sectionId = container.dataset.sectionId;
    if (!sectionId) {
      return;
    }

    if (instances[sectionId]) {
      instances[sectionId].destroy(true, true);
      delete instances[sectionId];
    }

    var productsCount = parseInt(container.dataset.productsCount || '0', 10);
    if (!productsCount) {
      return;
    }

    var autoscrollEnabled = container.dataset.autoscroll === 'true';
    var autoscrollDelay = parseInt(container.dataset.autoscrollDelay || '3500', 10);
    var desktopPerView = parseFloat(container.dataset.desktopItemPerView || '3');
    var tablePerView = parseFloat(container.dataset.tableItemPerView || '2');
    var MobilPerView = parseFloat(container.dataset.mobileItemPerView || '1.5');

    var swiperConfig = {
      loop: true,
      slidesPerView: MobilPerView,
      spaceBetween: 10,
      pagination: {
        el: container.querySelector('.banner-products-swiper__pagination'),
        clickable: true
      },
      navigation: {
        nextEl: container.querySelector('.banner-products-swiper__arrow--next'),
        prevEl: container.querySelector('.banner-products-swiper__arrow--prev')
      },
      breakpoints: {
        750: {
          slidesPerView: tablePerView,
          spaceBetween: 15
        },
        990: {
          slidesPerView: desktopPerView,
          spaceBetween: 15
        }
      }
    };

    if (autoscrollEnabled) {
      swiperConfig.loop = productsCount > 3;
      swiperConfig.autoplay = {
        delay: autoscrollDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
      swiperConfig.speed = 700;
    }

    instances[sectionId] = new Swiper(container, swiperConfig);
  }

  function initAll(context) {
    var scope = context || document;
    var sliders = scope.querySelectorAll('.banner-products-swiper__slider');
    sliders.forEach(function (slider) {
      initSlider(slider);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var slider = event.target.querySelector('.banner-products-swiper__slider');
    if (!slider) {
      return;
    }

    var sectionId = slider.dataset.sectionId;
    if (!sectionId || !instances[sectionId]) {
      return;
    }

    instances[sectionId].destroy(true, true);
    delete instances[sectionId];
  });
})();
